import React from "react";
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";

interface StatisticDivProps extends RowItem {
    label: string,
    extentionClass: string,
    containerClass: string
    labelClass: string,
    class: string,
    model: string | number,
    children: React.ReactElement[] | React.ReactElement
}
function StatisticDiv(props: Partial<StatisticDivProps>) {
    return (
        <div className={`rounded border border-1 ${props.containerClass! + props.extentionClass!}`}>
            <div className={`text-start mx-1 my-1 ${props.labelClass}`}>
                {app.translate(props.label)}
                <div className={`d-inline-block mx-2 fw-bold ${props.class}`}>{props.model}</div>
            </div>
        </div>
    );
}

StatisticDiv.defaultProps = {
    class: "col-12 col-lg-auto bg-body border-primary-subtle shadow-sm ",
    labelClass: "text-primary-emphasis fw-normal",
    resultClass: "text-success-emphasis ",
    extentionClass:""
};

export default StatisticDiv;
